"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hitTest = exports.hitTestAll = exports.clear = exports.update = exports.render = exports.addButton = exports.get = void 0;
var spritesUiGame_1 = require("@crokinole/recyclers/spritesUiGame");
var diveColors_1 = require("@dive/colors/diveColors");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var arrayUtils_sidecar_1 = require("@engine/arrayUtils-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var namespace = 'menu_creator';
var debugMenuSize = false;
var _obj = null;
function get() {
    // assert.notNil(_obj, 'board not loaded')
    if (!_obj) {
        _obj = {
            buttons: [],
            lastOverId: '',
            overId: '',
            downId: '',
        };
    }
    assert_sidecar_1.assert.notNil(_obj);
    return _obj;
}
exports.get = get;
var addButton = function (id, text, x, y, w, h, ox, oy, onClick) {
    assert_sidecar_1.assert.notEmptyString(id, namespace, 'addButton', 'missing id');
    var b = {
        id: id,
        text: text,
        x: x,
        y: y,
        w: w,
        h: h,
        ox: ox,
        oy: oy,
        isDisabled: false,
        isHighlighted: false,
        onClick: onClick,
    };
    get().buttons.push(b);
    return b;
};
exports.addButton = addButton;
var render = function () {
    var _a = get(), buttons = _a.buttons, overId = _a.overId;
    for (var iButton = 0; iButton < buttons.length; iButton++) {
        var button = buttons[iButton];
        var color = diveColors_1.diveColors.gray;
        if (button.isDisabled) {
            color = diveColors_1.diveColors.blueGray;
        }
        if (button.isHighlighted) {
            color = diveColors_1.diveColors.pureWhite;
        }
        if (button.id === overId) {
            color = diveColors_1.diveColors.pureWhite;
        }
        var x = button.x, y = button.y, w = button.w, h = button.h, ox = button.ox, oy = button.oy, text = button.text;
        if (debugMenuSize) {
            spritesUiGame_1.spritesUiGame.getNext(x, y, sprites_sidecar_1.sprites.crokinoleCrokinolePeg[0]).tint =
                diveColors_1.diveColors.orange;
            spritesUiGame_1.spritesUiGame.getNext(x, y + h, sprites_sidecar_1.sprites.crokinoleCrokinolePeg[0]).tint =
                diveColors_1.diveColors.orange;
            spritesUiGame_1.spritesUiGame.getNext(x + w, y, sprites_sidecar_1.sprites.crokinoleCrokinolePeg[0]).tint =
                diveColors_1.diveColors.orange;
            spritesUiGame_1.spritesUiGame.getNext(x + w, y + h, sprites_sidecar_1.sprites.crokinoleCrokinolePeg[0]).tint = diveColors_1.diveColors.orange;
        }
        var imgShadow = spritesUiGame_1.spritesUiGame.getNext(x + ox + sprites_sidecar_1.sprites.crokinoleButtonShadow[0].w * 0.2, y + oy, sprites_sidecar_1.sprites.crokinoleButtonShadow[0]);
        imgShadow.tint = diveColors_1.diveColors.pureBlack;
        imgShadow.alpha = 0.75;
        diveFont_sidecar_1.diveFont.writeAbsolute(x + ox, y + oy, text, 1, color);
    }
};
exports.render = render;
var update = function () {
    // Game position items
    // let { x, y } = voyageCamera.getAdjustedMousePosition()
    // let mx = x
    // let my = y
    var _a = voyageCamera_sidecar_1.voyageCamera.getUiMousePosition(), mx = _a.mx, my = _a.my;
    // console.log('mx', mx, 'my', my)
    exports.hitTestAll(mx, my, true);
};
exports.update = update;
var clear = function () {
    arrayUtils_sidecar_1.arrayUtils.clear(get().buttons);
};
exports.clear = clear;
var hitTestAll = function (mx, my, official) {
    var buttons = get().buttons;
    get().lastOverId = get().overId;
    get().overId = '';
    for (var iButton = 0; iButton < buttons.length; iButton++) {
        var button = buttons[iButton];
        if (button.isDisabled) {
            continue;
        }
        if (exports.hitTest(mx, my, button.x, button.y, button.w, button.h, official, button.id)) {
            clickEater_sidecar_1.clickEater.setHoverCursor();
            if (clickEater_sidecar_1.clickEater.isLeftFirstDownAndUneaten()) {
                clickEater_sidecar_1.clickEater.tempEat();
                console.log(namespace, 'clicked menu', button.id);
                if (button.onClick) {
                    button.onClick();
                }
            }
            clickEater_sidecar_1.clickEater.tempEatCursor();
            return true;
        }
    }
    return false;
};
exports.hitTestAll = hitTestAll;
var hitTest = function (mx, my, x, y, w, h, official, id) {
    // let overId = ''
    if (clickEater_sidecar_1.clickEater.isCursorEaten()) {
        return false;
    }
    if (mx >= x && my >= y) {
        if (mx <= x + w && my <= y + h) {
            // overId = id
            get().overId = id;
            // if (official) {
            //   if (clickEater.isLeftFirstDownAndUneaten()) {
            //     // goatUiConfirm.setOpen(true)
            //   }
            // }
            return true;
        }
    }
    return false;
    //   let wasOver = c.isOver
    //   if (official) {
    //     c.isOver = false
    //   }
    //   let tx = x
    //   let ty = y
    //   if (c.inGameSpace && official) {
    //     let gs = voyageCamera.getUiPositionToGamePosition(x, y)
    //     tx = gs.x
    //     ty = gs.y
    //   }
    //   if (tx >= c.x - c.feather && ty >= c.y - c.feather) {
    //     if (tx <= c.x + c.w + c.feather && ty <= c.y + c.h + c.feather) {
    //       overId = c
    //       // console.log('button hit test over', official)
    //       if (official) {
    //         c.isOver = true
    //         if (!wasOver) {
    //           c.onMouseOver(c)
    //           voyageSounds.playbuttonMouseOver()
    //         }
    //         if (c.isDown && !clickEater.isLeftDownRegardless()) {
    //           c.isDown = false
    //           voyageSounds.playButtonClick()
    //           c.onClick(c)
    //           clickEater.tempEat()
    //         } else {
    //           c.isDown = false
    //           if (clickEater.isLeftDownRegardless()) {
    //             c.isDown = true
    //             clickEater.tempEat()
    //           } else {
    //           }
    //         }
    //       }
    //       // if (clickEater.isLeftFirstDownAndUneaten()) {
    //       //   // goatUiConfirm.setOpen(true)
    //       // }
    //     }
    //   if (official) {
    //     if (!c.isOver) {
    //       c.isDown = false
    //     }
    //   }
    // return overId !== null
};
exports.hitTest = hitTest;
